// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBarBlock__Z43Af {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.progressBarBlockPercent__TS1hN {
  margin-right: 5px;
  color: var(--tables-title-text);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.progressBlock__mflSv {
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 5px;
}

.progressBlockItem__rotdl {
  width: 20px;
  height: 3px;
  background: var(--tables-title-progress-bar);
}

.activeItem__lvQC1 {
  background: var(--buttons-surface);
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ProgressBar/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,WAAA;EACA,4CAAA;AAzEF;;AA4EA;EACE,kCAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.progressBarBlock {\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n}\n\n.progressBarBlockPercent {\n  margin-right: 5px;\n  color: var(--tables-title-text);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.progressBlock {\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.progressBlockItem {\n  width: 20px;\n  height: 3px;\n  background: var(--tables-title-progress-bar);\n}\n\n.activeItem {\n  background: var(--buttons-surface);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBarBlock": `progressBarBlock__Z43Af`,
	"progressBarBlockPercent": `progressBarBlockPercent__TS1hN`,
	"progressBlock": `progressBlock__mflSv`,
	"progressBlockItem": `progressBlockItem__rotdl`,
	"activeItem": `activeItem__lvQC1`
};
module.exports = ___CSS_LOADER_EXPORT___;
